import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { INIT_TOPICS_GROUP_STORE } from '../data/actionTypes';
import { selectAttachedCluster } from '../data/topicEditor/slice';
import { topicsGroupStore, useDispatch, useSelector } from '../store';
import { TopicsRecommendationsContainer } from './recommendations/TopicsRecommendationsContainer';
import { TopicEditor } from './TopicEditor';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TopicsGroup = ({
  contentId,
  artifacts
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: INIT_TOPICS_GROUP_STORE,
      payload: {
        contentId
      }
    });
  }, [contentId, dispatch]);
  const attachedCluster = useSelector(selectAttachedCluster);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TopicEditor, {}), attachedCluster && /*#__PURE__*/_jsx(TopicsRecommendationsContainer, {
      artifacts: artifacts
    })]
  });
};
export const TopicsGroupWrapper = ({
  contentId,
  artifacts
}) => {
  return /*#__PURE__*/_jsx(Provider, {
    store: topicsGroupStore,
    children: /*#__PURE__*/_jsx(TopicsGroup, {
      contentId: contentId,
      artifacts: artifacts
    })
  });
};